/* EFECTOS — los plugins de GSAP puestos a trabajar. Cuadros Splash (15 sep 2026).

   cs-cine.js se ocupa del movimiento atado al SCROLL. Este fichero es lo otro:
   lo que pasa cuando alguien TOCA algo — pincha un ancla, marca un favorito,
   añade a la cesta, escribe en el buscador.
   (Hubo un quinto, agarrar la pared del pasillo: retirado, ver el bloque 1.)

   Cada efecto pide su plugin al mostrador (cs-libreria.js) y solo entonces se
   descarga. Un visitante que no marque ningún favorito no baja MorphSVG.

   > LA REGLA DE ORO, la de siempre: nada de esto es necesario para comprar.
   > Si un plugin no llega, el botón sigue funcionando y la página sigue
   > entera. Por eso cada efecto se engancha ENCIMA de algo que ya funciona,
   > nunca en su lugar.
*/
(function () {
  'use strict';

  var caja = { pasos: [] };
  window.csEfectos = caja;
  function apunte(que, dato) {
    caja.pasos.push({ t: Math.round(performance.now()), que: que, dato: dato });
  }

  /* El mismo interruptor que el resto de la casa, con su memoria. */
  var parametro = null;
  try {
    parametro = new URLSearchParams(window.location.search).get('vivo');
    if (parametro === 'si' || parametro === 'no') sessionStorage.setItem('cs-vivo', parametro);
    else if (!parametro) parametro = sessionStorage.getItem('cs-vivo');
  } catch (e) { /* sin almacén: manda la URL */ }

  if (parametro === 'no') return apunte('apagado');
  var forzado = parametro === 'si';
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducido && !forzado) return apunte('movimiento-reducido');
  if (!window.csLib) return apunte('sin-libreria');

  var raton = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function cuandoQuepa(fn) {
    function luego() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 3000 });
      else setTimeout(fn, 1200);
    }
    if (document.readyState === 'complete') luego();
    else window.addEventListener('load', luego, { once: true });
  }

  /* ================================================================
     La curva de la casa
     ================================================================ */

  /* Una sola curva para todo lo de aquí, definida con CustomEase. Las de
     serie de GSAP (`power3.out` y compañía) son simétricas y previsibles;
     ésta arranca perezosa y frena largo, que es como Gabriel quiere el
     movimiento de esta tienda. Tenerla con nombre evita que cada efecto
     invente la suya y que al final nada se parezca a nada. */
  var CURVA = 'power3.out'; /* la de reserva hasta que llegue CustomEase */

  function conCurva() {
    return window.csLib.pide('customease').then(function () {
      if (window.CustomEase) {
        window.CustomEase.create('csGaleria', 'M0,0 C0.16,0 0.1,1 1,1');
        CURVA = 'csGaleria';
      }
    }).catch(function () { /* se queda power3.out, que se parece bastante */ });
  }

  /* ================================================================
     1. La pared se agarraba — RETIRADO (15 sep 2026)
     ================================================================ */

  /* Aquí hubo un Draggable + InertiaPlugin para agarrar la pared del pasillo
     y lanzarla. Se retira, y conviene saber por qué para no reponerlo igual:

     · NUNCA LLEGÓ A FUNCIONAR. El tirador que creaba salía con
       `display: none` heredado de la sección, así que medía 0x0 y no
       escuchaba un solo gesto. Y como Draggable se creaba sin quejarse, no
       había ningún error que lo delatara: parecía puesto y no lo estaba.
     · Y aunque hubiera funcionado, era mala idea. El pasillo YA secuestra el
       scroll mientras está anclado; poner encima un arrastre que también
       mueve el scroll son dos mecanismos peleando por el mismo gesto, y es
       justo lo que hace que la página se sienta rota.

     Si algún día se quiere el arrastre, el sitio es el pasillo EN REPOSO —
     la tira con `overflow-x: auto`—, que ya se arrastra sola con el dedo y
     no necesita plugin ninguno. */

  /* ================================================================
     2. Las anclas se deslizan — ScrollToPlugin
     ================================================================ */

  /* La pastilla del 10% enlaza a #cs-suscribete, que está al final de la
     portada. De un salto no se entiende de dónde a dónde has ido; deslizando
     sí. Se hace con delegación, así que vale para cualquier ancla que se
     añada después. */
  function anclasSeDeslizan() {
    if (!document.querySelector('a[href*="#"]')) return;

    document.addEventListener('click', function (e) {
      var enlace = e.target.closest && e.target.closest('a[href]');
      if (!enlace || e.metaKey || e.ctrlKey || e.shiftKey || enlace.target === '_blank') return;

      var href = enlace.getAttribute('href') || '';
      var i = href.indexOf('#');
      if (i < 0 || href.length === i + 1) return;
      /* Solo anclas de ESTA página: '#x' o '/ruta-actual#x'. */
      var ruta = href.slice(0, i);
      if (ruta && ruta !== window.location.pathname) return;

      var destino = document.getElementById(href.slice(i + 1));
      if (!destino) return;

      e.preventDefault();
      window.csLib.pide('scrollto').then(function () {
        var cabecera = document.querySelector('.section-header, .header-wrapper');
        var margen = cabecera ? cabecera.offsetHeight + 16 : 16;
        gsap.to(window, {
          duration: 1.1,
          ease: CURVA,
          scrollTo: { y: destino, offsetY: margen, autoKill: true },
          /* El foco se mueve al destino al terminar: sin esto, quien navega
             con teclado se queda con el foco arriba y el siguiente tabulador
             lo devuelve al principio. */
          onComplete: function () {
            destino.setAttribute('tabindex', '-1');
            destino.focus({ preventScroll: true });
          }
        });
        apunte('ancla', href);
      }).catch(function () {
        destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ================================================================
     3. El corazón se llena — MorphSVG
     ================================================================ */

  /* El icono son DOS svg superpuestos —contorno y relleno— que hasta ahora se
     cruzaban con opacidad. MorphSVG lleva el trazo del contorno hasta la
     silueta del relleno: el corazón no se enciende, se LLENA.

     SOLO LA FORMA, NADA MÁS. El latido ya lo hace cs-sala.js con la clase
     `es-latido`, y la escala de esa animación de CSS y una de GSAP sobre el
     mismo botón se pisarían. Aquí se hace únicamente lo que el CSS no puede:
     interpolar un contorno hasta otro.

     Y SE ESCUCHA EL EVENTO, NO EL CLIC. La primera versión escuchaba `click`
     en el documento y no se disparaba nunca: favoritos.js resuelve el suyo en
     fase de CAPTURA y llama a `stopPropagation()`, así que a la fase de
     burbujeo no llega nada. Tampoco valía mirar `aria-pressed`, por lo mismo.
     favoritos.js publica `cs:favoritos-cambio` con el handle y si ha quedado
     marcado: ése es el enganche bueno, y es el que ya usa cs-sala.js. */
  function corazonSeLlena() {
    if (!document.querySelector('[data-cs-fav]')) return;

    document.addEventListener('cs:favoritos-cambio', function (e) {
      var d = e.detail || {};
      if (!d.favorito) return; /* al desmarcar no se celebra nada */

      window.csLib.pide('morphsvg').then(function () {
        if (!window.MorphSVGPlugin) return;
        var botones = document.querySelectorAll(
          '[data-cs-fav="' + CSS.escape(d.handle) + '"]'
        );
        Array.prototype.forEach.call(botones, function (boton) {
          var out = boton.querySelector('.cs-fav__ico-out path');
          var fill = boton.querySelector('.cs-fav__ico-fill path');
          if (!out || !fill) return;

          var original = out.getAttribute('d');
          gsap.timeline()
            .to(out, { morphSVG: fill.getAttribute('d'), duration: 0.38, ease: CURVA })
            /* Se devuelve el contorno a su forma. El <svg> se reutiliza en
               cada pulsación y, sin esto, a la segunda ya estaría deformado. */
            .set(out, { attr: { d: original } }, '+=0.15');
        });
        apunte('corazon', d.handle);
      }).catch(function () { /* sin morph, el cambio de opacidad de siempre */ });
    });
  }

  /* ================================================================
     4. La obra vuela a la cesta — MotionPathPlugin
     ================================================================ */

  /* Al añadir al carrito, una copia de la obra sale de la ficha y viaja hasta
     el icono de la cesta describiendo una curva, encogiéndose. Es el gesto
     que le dice al cliente DÓNDE ha ido lo que acaba de comprar — la cesta
     está arriba a la derecha y mucha gente no la mira.

     Vuela un CLON, nunca la obra de verdad: si se moviera el original, un
     fallo a media animación dejaría la ficha sin foto. El clon se quita solo
     al llegar, pase lo que pase. */
  function obraVuelaALaCesta() {
    var cesta = document.getElementById('cart-icon-bubble');
    if (!cesta) return;

    /* El tema publica 'cart-update' por su bus de eventos (pubsub.js). Aquí
       se escucha el evento del DOM que dispara cs-sala.js, que ya hace de
       puente. */
    document.addEventListener('cs:anadido', function (ev) {
      var origen = (ev.detail && ev.detail.imagen) ||
        document.querySelector('.product__media-item.is-active img, .product__media-item img');
      if (!origen) return;
      volar(origen);
    });

    function volar(origen) {
      window.csLib.pide('motionpath').then(function () {
        if (!window.MotionPathPlugin) return;
        var r = origen.getBoundingClientRect();
        var rc = cesta.getBoundingClientRect();

        var clon = origen.cloneNode(true);
        clon.className = 'cs-vuelo';
        clon.removeAttribute('id');
        gsap.set(clon, {
          position: 'fixed',
          left: r.left, top: r.top, width: r.width, height: r.height,
          margin: 0, zIndex: 9999, pointerEvents: 'none', borderRadius: '2px'
        });
        document.body.appendChild(clon);

        var dx = rc.left + rc.width / 2 - (r.left + r.width / 2);
        var dy = rc.top + rc.height / 2 - (r.top + r.height / 2);

        gsap.timeline({
          onComplete: function () { clon.remove(); }
        })
          .to(clon, {
            duration: 1.05,
            ease: 'power2.inOut',
            motionPath: {
              /* Un arco que sube antes de caer: en línea recta parece un
                 error de posición, en curva parece un gesto. */
              path: [
                { x: 0, y: 0 },
                { x: dx * 0.45, y: dy * 0.25 - 140 },
                { x: dx, y: dy }
              ],
              curviness: 1.4
            }
          })
          .to(clon, { scale: 0.08, opacity: 0.35, duration: 1.05, ease: 'power2.in' }, 0)
          .to(cesta, { scale: 1.25, duration: 0.2, ease: 'back.out(4)' }, 0.85)
          .to(cesta, { scale: 1, duration: 0.45, ease: 'elastic.out(1, 0.5)' }, 1.05);
        apunte('vuelo-a-cesta');
      }).catch(function () { /* sin motionpath, no vuela nada y no pasa nada */ });
    }

    /* Puente por si cs-sala.js no publica el evento: se escucha el bus del
       propio tema, que es lo que usa Dawn al añadir al carrito. */
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        var img = document.querySelector('.product__media-item.is-active img, .product__media-item img');
        if (img) volar(img);
      });
    }
  }

  /* ================================================================
     5. El buscador se escribe solo — TextPlugin
     ================================================================ */

  /* El campo de búsqueda de la portada tiene un `placeholder` largo con tres
     ejemplos separados por puntos. Puestos a la vez son una lista que nadie
     lee; escritos uno detrás de otro, son una sugerencia.

     Se escribe en el PLACEHOLDER, no en el valor: si se tocara el valor,
     quien pulse "Buscar" sin escribir nada buscaría la sugerencia. Y en
     cuanto el visitante escribe o enfoca, se para y se queda quieto: una
     animación que se mueve mientras tecleas es una distracción. */
  function buscadorSeEscribeSolo() {
    var campo = document.querySelector('.cs-cat__input');
    if (!campo || !raton) return;

    var base = campo.getAttribute('placeholder') || '';
    var ejemplos = base.split('·').map(function (s) { return s.trim(); }).filter(Boolean);
    if (ejemplos.length < 2) return;

    /* TextPlugin solo puede escribir sobre nodos con `nodeName`. El buscador
       necesita animar el placeholder, no el contenido del input, así que un
       objeto proxy con la propiedad `text` hacía que el plugin intentara
       leer `nodeName.toUpperCase()` y lanzara una excepción en cada tic del
       reloj de GSAP. Esa excepción también interrumpía el raf que mueve
       Lenis, dejando el scroll bloqueado al volver arriba. Se escribe el
       texto por tramos con un progreso numérico y se mantiene Lenis intacto. */
    if (!window.gsap) return;
    var proxy = { progreso: 0 };
    function pintar(texto) {
      campo.setAttribute('placeholder', texto.slice(0, Math.round(proxy.progreso * texto.length)));
    }
      var linea = gsap.timeline({ repeat: -1, paused: true });

      ejemplos.forEach(function (texto) {
        linea
          .to(proxy, {
            duration: Math.max(0.7, texto.length * 0.045),
            progreso: 1,
            ease: 'none',
            onUpdate: function () { pintar(texto); }
          })
          .to({}, { duration: 1.6 })
          .to(proxy, {
            duration: 0.35,
            progreso: 0,
            ease: 'none',
            onUpdate: function () { pintar(texto); }
          });
      });

      /* Solo mientras se ve: si la portada está pasada de largo, no tiene
         sentido gastar fotogramas escribiendo algo que nadie mira. */
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (x) { x.isIntersecting ? linea.play() : linea.pause(); });
      }, { threshold: 0.2 });
      io.observe(campo);

      function parar() {
        linea.kill();
        io.disconnect();
        campo.setAttribute('placeholder', base);
      }
      campo.addEventListener('focus', parar, { once: true });
      campo.addEventListener('input', parar, { once: true });
      apunte('buscador', ejemplos.length);
    /* Si GSAP no llega, se queda el placeholder de siempre. */
  }

  /* ================================================================
     Arranque
     ================================================================ */

  cuandoQuepa(function () {
    window.csLib.pide('gsap')
      .then(conCurva)
      .then(function () {
        anclasSeDeslizan();
        corazonSeLlena();
        obraVuelaALaCesta();
        buscadorSeEscribeSolo();
        apunte('armado');
      })
      .catch(function (e) {
        apunte('sin-gsap', String((e && e.message) || e));
      });
  });
})();
